(() => {
  'use strict';
  if (window.KMCartPairData) return;

  const cache = new Map();
  const enabled = value => ['1', 'true', 'yes'].includes(String(value ?? '').trim().toLowerCase());
  const text = value => String(value ?? '').trim();

  function fitment() {
    const empty = {year: '', make: '', model: ''};
    try {
      if (localStorage.getItem('km_shop_without_ride') === '1') return empty;
      const rides = JSON.parse(localStorage.getItem('km_garage_rides') || '[]');
      if (!Array.isArray(rides)) return empty;
      const ride = rides.find(ride => ride && enabled(ride.isCurrent ?? ride.is_current ?? ride.currentType ?? ride.current_type))
        || rides.find(ride => ride && enabled(ride.primaryVehicle ?? ride.primary_vehicle));
      if (!ride) return empty;
      const year = Number(ride.year);
      return {year: Number.isInteger(year) && year > 0 ? year : '', make: text(ride.make), model: text(ride.model)};
    } catch (error) {
      return empty;
    }
  }

  function key(handle, pageNum = 1, pageSize = 3) {
    return JSON.stringify([window.api?.env, handle, fitment(), pageNum, pageSize]);
  }

  function load(handle, requestedPage = 1, requestedSize = 3) {
    const pageNum = Number.isSafeInteger(requestedPage) && requestedPage > 0 ? requestedPage : 1;
    const pageSize = [4, 8].includes(requestedSize) ? requestedSize : 3;
    const requestKey = key(handle, pageNum, pageSize);
    const existing = cache.get(requestKey);
    if (existing && Date.now() < existing.expires) return existing.promise;
    if (!window.api?.post) return Promise.reject(new Error('Recommendations are not ready. Please retry.'));
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000);
    const entry = {expires: Date.now() + 60000};
    entry.promise = window.api.post('/api/product/recommend/list', {
      handle, ...fitment(), pageNum, pageSize, shop: 'kemimoto_us'
    }, false, {}, {signal: controller.signal}).then(result => {
      if (Number(result?.code) !== 200 || !Array.isArray(result.rows)) {
        throw new Error('Unable to load related products. Please retry.');
      }
      const seen = new Set([handle]);
      const products = result.rows.filter(product => {
        const productHandle = text(product?.handle);
        if (!/^[a-z0-9][a-z0-9-]*$/i.test(productHandle) || seen.has(productHandle)) return false;
        if (product.status && product.status !== 'active') return false;
        seen.add(productHandle);
        return true;
      }).slice(0, pageSize);
      const total = Number(result.total);
      return {products, total: Number.isSafeInteger(total) && total >= 0 ? total : result.rows.length,
        pageNum, pageSize};
    }).catch(error => {
      if (cache.get(requestKey) === entry) cache.delete(requestKey);
      throw error;
    }).finally(() => clearTimeout(timeout));
    cache.set(requestKey, entry);
    while (cache.size > 24) cache.delete(cache.keys().next().value);
    return entry.promise;
  }

  window.KMCartPairData = {key, load};
})();
